import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReferrerPortalComponent } from './referrer-portal.component';
import { ReferrerPortalHomeComponent } from './referrer-portal-home/referrer-portal-home.component';

const routes: Routes = [{
  path: '', component: ReferrerPortalComponent,
  children: [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: ReferrerPortalHomeComponent },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReferrerPortalRoutingModule { }
